import type { ExperimentConfig } from '../simulation/types';
import type { ProgressState } from './progress';
import type { RunRecord } from './runRecord';

export interface Prefs {
  splitPercent: number;
  speed: number;
  reducedMotion: 'system' | 'on' | 'off';
  showAcceleration: boolean;
  showContributions: boolean;
}

export interface ExperimentState {
  presetId: string;
  labStepId: string | null;
  config: ExperimentConfig;
}

/** Everything persisted in browser storage. */
export interface PersistedData {
  currentLessonId: string;
  runCounter: number;
  runs: RunRecord[];
  progress: ProgressState;
  predictions: Record<string, string>;
  reflections: Record<string, string>;
  comparison: string[];
  experiment: ExperimentState | null;
  prefs: Prefs;
}

export const DEFAULT_PREFS: Prefs = {
  splitPercent: 45,
  speed: 1,
  reducedMotion: 'system',
  showAcceleration: false,
  showContributions: false,
};

export function emptyData(): PersistedData {
  return {
    currentLessonId: 'm0',
    runCounter: 0,
    runs: [],
    progress: { evidence: {}, gates: {} },
    predictions: {},
    reflections: {},
    comparison: [],
    experiment: null,
    prefs: { ...DEFAULT_PREFS },
  };
}
